<template>
  <div class="ticket-link-parts">
    <atom-router-button
      v-if="purchasedTicketStatus === 'hasAvailableTodayTickets'"
      to="/mypage/ticket-today"
      :linkText="$tc('HomePage.countdown.ticket.todayTickets')"
    />
    <atom-router-button
      v-else-if="purchasedTicketStatus === 'hasTickets'"
      class="ticket-link-parts__button"
      to="/mypage/ticket-list"
      :linkText="$tc('HomePage.countdown.ticket.purchasedTickets')"
      colorType="tertiary"
    />
    <atom-icon-link-button
      v-else
      class="ticket-link-parts__button"
      :url="ecSiteUrl"
      :linkText="$tc('HomePage.countdown.ticket.unPurchased')"
      colorType="tertiary"
      :imgPath="require('@/assets/img/icon/icon_external_link_gray75.svg')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import AtomRouterButton from '@/components/atoms/AtomRouterButton.vue'
import AtomIconLinkButton from '@/components/atoms/AtomIconLinkButton.vue'
import Const from '@/util/Const'
import I18n from '@/locales/I18n'

export type PurchasedTicketStatusType = 'noTickets' | 'hasTickets' | 'hasAvailableTodayTickets'

export default defineComponent({
  name: 'TicketLinkParts',
  components: {
    AtomIconLinkButton,
    AtomRouterButton,
  },
  props: {
    purchasedTicketStatus: {
      type: String as PropType<PurchasedTicketStatusType>,
      default: 'noTickets',
    },
  },
  setup() {
    // ECサイトURL
    const ecSiteUrl =
      I18n.locale === 'ja'
        ? Const.EXTERNAL_LINKS.ABOUT_EC_SITE.JA
        : Const.EXTERNAL_LINKS.ABOUT_EC_SITE.EN

    return {
      ecSiteUrl,
    }
  },
})
</script>

<style scoped lang="scss">
.ticket-link-parts {
  width: 100%;

  &__button {
    width: 100%;
    max-width: 345px;
    margin: 0 auto;
    line-height: 1;
    background-color: $white;
    color: $gray75;
    border: 1px solid rgba(#000, 0.2);

    ::v-deep {
      img {
        width: 12px;
        height: 12px;
      }
    }
  }
}
</style>
